import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import "../../styles/vendor/react-checkbox-tree.css";
import { Link } from "react-router-dom";
import BasicSelect from "./fields/BasicSelect";
import { COUNTRIES } from "../../constants/countries";
import axios from "axios";
import { baseValue } from "../../libs/utils";
import { FormikPropTypes } from "./helpers/formikPropTypes";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this._handleVatChange = this._handleVatChange.bind(this);
  }

  static propTypes = {
    ...FormikPropTypes,
    company: PropTypes.object,
    overwriteValidate: PropTypes.func,
    hideType: PropTypes.bool
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { company } = nextProps;
    const currentProps = this.props;

    if (currentProps.company !== company) {
      currentProps.setValues({
        id: baseValue(company.id),
        vat: baseValue(company.vat),
        name: baseValue(company.name),
        address: baseValue(company.addressLine1),
        postal_code: baseValue(company.zip),
        city: baseValue(company.city),
        country: baseValue(company.country),
        email: baseValue(company.email),
        phonetele: baseValue(company.telephone),
        accountingCustomerCode: baseValue(company.accountingCustomerCode),
        type: baseValue(company.type, "company"),
        redirect: true
      });
    }

    if (currentProps.formSubmitting && !nextProps.formSubmitting) {
      currentProps.setSubmitting(false);
    }
  }

  _handleVatChange(e) {
    const { props, _extractComponent } = this;
    const { values } = props;
    const vat = e.target.value.replace(/[^\w]/g, "");

    if (
      values.name === "" &&
      values.country === "" &&
      values.city === "" &&
      values.address === "" &&
      values.postal_code === "" &&
      vat.length > 7
    ) {
      axios
        .get(
          "http://apilayer.net/api/validate?access_key=" +
            process.env.REACT_APP_VATLAYER_KEY +
            "&vat_number=" +
            vat +
            "&format=1",
          {
            transformRequest: [
              (data, headers) => {
                delete headers.common.Authorization;
                return data;
              }
            ]
          }
        )
        .then(function(response) {
          if (response.data.valid) {
            const { company_address, company_name } = response.data;
            props.setFieldValue("name", company_name);

            axios
              .get(
                "https://maps.googleapis.com/maps/api/geocode/json?address=" +
                  company_address.replace(/\n/g, " ").replace(/ /g, "+") +
                  "&key=" +
                  process.env.REACT_APP_GOOGLE_KEY,
                {
                  transformRequest: [
                    (data, headers) => {
                      delete headers.common.Authorization;
                      return data;
                    }
                  ]
                }
              )
              .then(function(response) {
                if (response.data.results.length > 0) {
                  const components =
                    response.data.results[0].address_components;
                  const postal_code = _extractComponent(
                    components,
                    "postal_code"
                  );
                  const street = _extractComponent(components, "route");
                  const city = _extractComponent(components, "locality");
                  const number = _extractComponent(components, "street_number");
                  const country = _extractComponent(
                    components,
                    "country",
                    true
                  );

                  props.setFieldValue("country", country);
                  props.setFieldValue("city", city);
                  props.setFieldValue("address", street + " " + number);
                  props.setFieldValue("postal_code", postal_code);
                }
              });
          }
        });
    }
  }

  _extractComponent(components, key, short = false) {
    var matchingComps = components.filter(
      component => component.types.indexOf(key) > -1
    );
    if (matchingComps.length > 0) {
      if (short) {
        return matchingComps[0].short_name;
      } else {
        return matchingComps[0].long_name;
      }
    } else {
      return "";
    }
  }

  render() {
    const props = this.props;
    const { hideType } = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />
          <div className="form-group m-form__group row">
            <div className="col-xl-3">
              <BasicInput
                {...props}
                name="vat"
                type="text"
                label="VAT identification number"
                noFormGroup={true}
                placeholder="BE 0123.456.789"
                onBlur={this._handleVatChange}
              />
            </div>
            <div className="col-xl-6">
              <BasicInput
                {...props}
                name="name"
                type="text"
                label="Company Name"
                noFormGroup={true}
                required
              />
            </div>
            <div className="col-xl-3">
              <BasicInput
                  {...props}
                  name="accountingCustomerCode"
                  type="text"
                  label="Accounting customer code"
                  placeholder="exact_00001"
                  noFormGroup={true}
              />
            </div>
          </div>
          <div className="form-group m-form__group row">
            <div className="col-xl-7">
              <BasicInput
                {...props}
                name="address"
                type="text"
                label="Address"
                noFormGroup={true}
              />
            </div>
            <div className="col-xl-2">
              <BasicInput
                {...props}
                name="postal_code"
                type="text"
                label="Postal Code"
                noFormGroup={true}
              />
            </div>
            <div className="col-xl-3">
              <BasicInput
                {...props}
                name="city"
                type="text"
                label="City"
                noFormGroup={true}
              />
            </div>
          </div>

          <div className="form-group m-form__group row">
            <div className="col-xl-4">
              <BasicSelect
                {...props}
                name="country"
                label="Country"
                placeholder="Choose a country"
                noFormGroup={true}
                options={COUNTRIES.map(country => {
                  return {
                    value: country.value,
                    title: country.label
                  };
                })}
              />
            </div>
            {!hideType && (
              <div className="col-xl-4">
                <BasicSelect
                  {...props}
                  name="type"
                  label="Type"
                  noFormGroup={true}
                  options={[
                    {
                      value: "company",
                      title: "Company"
                    },
                    {
                      value: "artist",
                      title: "Artist"
                    },
                    {
                      value: "association",
                      title: "Association"
                    }
                  ]}
                />
              </div>
            )}

            <div className="col-xl-4">
              <BasicInput
                {...props}
                name="telephone"
                type="text"
                label="Phone"
                noFormGroup={true}
              />
            </div>
          </div>
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              {!props.company && [
                <button
                  key="1"
                  className={
                    "btn m-btn btn-primary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                  onClick={() => this.props.setFieldValue("redirect", false)}
                >
                  Add employee
                </button>,

                <button
                  key="2"
                  className={
                    "btn m-btn btn-secondary m--margin-left-10" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                >
                  Create
                </button>,

                <span key="3" className="m--margin-left-10">
                  or{" "}
                  <Link to="admin/companies" className="m-link m--font-bold">
                    Cancel
                  </Link>
                </span>
              ]}

              {props.company && [
                <button
                  key="1"
                  className={
                    "btn m-btn btn-primary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                >
                  Update
                </button>,

                <span key="2" className="m--margin-left-10">
                  or{" "}
                  <Link
                    to={hideType ? "/welcome" : "admin/companies"}
                    className="m-link m--font-bold"
                  >
                    Cancel
                  </Link>
                </span>
              ]}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const CompaniesForm = withFormik({
  mapPropsToValues: props => {
    const company = baseValue(props.company, {});

    let values = {
      id: baseValue(company.id),
      vat: baseValue(company.vat),
      name: baseValue(company.name),
      address: baseValue(company.addressLine1),
      postal_code: baseValue(company.zip),
      city: baseValue(company.city),
      country: baseValue(company.country),
      phone: baseValue(company.telephone),
      accountingCustomerCode: baseValue(company.accountingCustomerCode),
      type: baseValue(company.type, "company"),
      redirect: true
    };

    return values;
  },
  validate: (values, props) => {
    if (props.overwriteValidate) {
      return props.overwriteValidate(values);
    }

    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default CompaniesForm;
